export const COURSE_PAUSE_TYPE_PLACEHOLDER_MAP = {
  'future-dated': 'Pause Requests',
  'back-dated': 'Reset Requests',
};
